import type { Location } from '@/api/types';

/**
 * The logo for the title bar, which is not always the same image as everywhere else.
 *
 * A title-bar variant is cropped and proportioned for a wide, short slot; the general logo is drawn to stand
 * on its own. A brand that has supplied both wants each used where it belongs.
 *
 * FALLS BACK TO THE GENERAL LOGO when there is no title-bar variant, which is most brands until they upload
 * one. Without the fallback, adding this field would have quietly replaced every existing logo in the title
 * bar with the restaurant's name in type - a visible downgrade for brands that changed nothing.
 *
 * Light surfaces only, like everything else here. The dark-surface pair is for when the app honours a dark
 * scheme, which it does not yet.
 */
export function titleBarLogoUrl(location: Pick<Location, 'logoOnLightTitleBarUrl' | 'logoOnLightUrl'>): string | null {
    return location.logoOnLightTitleBarUrl ?? location.logoOnLightUrl;
}
